import React, { useState } from "react";
import moment from "moment";
import { Checkbox,Chip, TableCell, TableRow, Tooltip, } from "@material-ui/core";
import { VisibilityOutlined, DeleteOutline, Edit } from '@material-ui/icons';
import RevertIcon from "../../../assets/images/Revert_Icon.svg"
import { checkPermission } from "../../../utils_v2";
import { displayDateFormat } from "../../../../constants";
import { numberWithCommas } from "../../../../utils";

const SvEventsList = ({ isSvEvents, deleted, item, index, onEditFn, onViewFn, onRevert, onDelete, toggleBulkOps, bulkIds, unLink, isEngine, isApu }) => {
	const [showMore, setShowMore] = useState({});
	const toggleDescription = (field) => {
		setShowMore({
			...showMore,
			[field]: !showMore[field]
		})
	}
	return (
		<>
			<TableRow key={index} className={item?.deleted_at ? "grey-out" : ''}>
				{!isSvEvents && !isEngine && !isApu ? <TableCell style={{ position: 'sticky', left: 0, backgroundColor: 'inherit', zIndex: 1, }}>
					<ul className="list-inline flex-centered" style={{ width: '130px' }} >
						{checkPermission('config_data', 'maintenance_program', 'D') &&<li className="list-inline-item hover-inline last-icon">
							<Checkbox checked={bulkIds.includes(item?.id)} onChange={(e) => { toggleBulkOps(item, e.target.checked) }} color="primary" size="small" />
						</li>}
						<li className="list-inline-item hover-inline last-icon" style={{ marginTop: "5px" }}>
							<Tooltip title='Veiw' arrow><VisibilityOutlined onClick={onViewFn} color="primary" fontSize="small" /></Tooltip>
						</li>
						{!item?.deleted_at && checkPermission('config_data', 'maintenance_program', 'U') ?
							<li className="list-inline-item hover-inline" onClick={onEditFn}>
								<Tooltip title='Edit' arrow><Edit color="primary" fontSize="small" /></Tooltip>
							</li>
							: null}
						{item?.deleted_at  && checkPermission('config_data', 'maintenance_program', 'RVT') ?
							<li className="list-inline-item hover-inline">
								<Tooltip title='Revert' arrow>
									<img
										src={RevertIcon}
										alt="Revert Icon"
										onClick={() => onRevert({ modal: true, data: item?.id })}
										style={{ width: "1rem", height: "1rem", cursor: 'pointer', fontSize: "1.25rem", margin: '4px' }}
										className="last-icon"
									/>
								</Tooltip>
							</li>
							: null}
						{!item?.deleted_at && checkPermission('config_data', 'maintenance_program', 'D') ?
							<li className="list-inline-item hover-inline" onClick={() => onDelete({ modal: true, data: item, })}>
								<Tooltip title='Delete' arrow><DeleteOutline color="secondary" fontSize="small" /></Tooltip>
							</li>
							: null}
					</ul>
				</TableCell> : !deleted ?
					<TableCell style={{ position: 'sticky', left: 0, backgroundColor: 'inherit', zIndex: 1, }}>
						{!item?.deleted_at ?
						<ul className="list-inline flex-centered" style={{ width: '130px' }}>
							{checkPermission('config_data', 'maintenance_program', 'D') && <>
							<li className="list-inline-item hover-inline last-icon">
								<Checkbox checked={bulkIds.includes(item?.id)} onChange={(e) => { toggleBulkOps(item, e.target.checked) }} color="primary" size="small" />
							</li>
							<li className="list-inline-item hover-inline" onClick={() => unLink({ modal: true, data: item})}>
								<Tooltip title='Unlink' arrow><DeleteOutline color="secondary" fontSize="small" /></Tooltip>
							</li></>}	
						</ul> : null }
					</TableCell> : null}
				<TableCell><div style={{ width: '150px' }}>{item?.name || '--'}</div></TableCell>
				<TableCell><div style={{ width: '150px' }}>{item?.asset_type?.label || '--'}</div></TableCell>
				<TableCell>
					<div style={{ width: '150px' }}>
						{item?.aircraft_type && item.aircraft_type.length > 0 &&item?.asset_type?.value===1  ? (
							<>
								{(showMore[`chip_${item.id}`] ? item.aircraft_type : item.aircraft_type.slice(0, 2)).map((type, idx) => (
									<Tooltip title={type?.name}><Chip key={idx} variant="outlined" size="small" label={type.name} style={{ fontSize: "12px", marginRight: 4, marginBottom: 4, maxWidth: "150px" }} /></Tooltip>
								))}
								{item.aircraft_type.length > 2 && !showMore[`chip_${item.id}`] && (
									<a href="#" onClick={(e) => {
										e.preventDefault();
										toggleDescription(`chip_${item.id}`);
									}} style={{ fontSize: '10px', color: '#0E7FE1', height: '10px', marginLeft: '5px' }}>
										+{item.aircraft_type.length - 2} more
									</a>
								)}
								{item.aircraft_type.length > 2 && showMore[`chip_${item.id}`] && (
									<a href="#" onClick={(e) => {
										e.preventDefault();
										toggleDescription(`chip_${item.id}`);
									}} style={{ fontSize: '10px', color: '#0E7FE1', height: '10px', marginLeft: '5px' }}>
										show less
									</a>
								)}
							</>
						) : '--'}
					</div>
				</TableCell>
				{!isSvEvents&&!isEngine && !isApu ?<>
				<TableCell>
					<div style={{ width: '150px' }}>
						{item?.engine_type && item.engine_type.length > 0 &&item?.asset_type?.value===2  ? (
							<>
								{(showMore[`chip_${item.id}`] ? item.engine_type : item.engine_type.slice(0, 2)).map((type, idx) => (
									<Tooltip title={type?.name}><Chip key={idx} variant="outlined" size="small" label={type.name} style={{ fontSize: "12px", marginRight: 4, marginBottom: 4, maxWidth: "150px" }} /></Tooltip>
								))}
								{item.engine_type.length > 2 && !showMore[`chip_${item.id}`] && (
									<a href="#" onClick={(e) => {
										e.preventDefault();
										toggleDescription(`chip_${item.id}`);
									}} style={{ fontSize: '10px', color: '#0E7FE1', height: '10px', marginLeft: '5px' }}>
										+{item.engine_type.length - 2} more
									</a>
								)}
								{item.engine_type.length > 2 && showMore[`chip_${item.id}`] && (
									<a href="#" onClick={(e) => {
										e.preventDefault();
										toggleDescription(`chip_${item.id}`);
									}} style={{ fontSize: '10px', color: '#0E7FE1', height: '10px', marginLeft: '5px' }}>
										show less
									</a>
								)}
							</>
						) : '--'}
					</div>
				</TableCell>
				<TableCell>
					<div style={{ width: '150px' }}>
						{item?.apu_type && item.apu_type.length > 0 &&item?.asset_type?.value===3  ? (
							<>
								{(showMore[`chip_${item.id}`] ? item.apu_type : item.apu_type.slice(0, 2)).map((type, idx) => (
									<Tooltip title={type?.name}><Chip key={idx} variant="outlined" size="small" label={type.name} style={{ fontSize: "12px", marginRight: 4, marginBottom: 4, maxWidth: "150px" }} /></Tooltip>
								))}
								{item.apu_type.length > 2 && !showMore[`chip_${item.id}`] && (
									<a href="#" onClick={(e) => {
										e.preventDefault();
										toggleDescription(`chip_${item.id}`);
									}} style={{ fontSize: '10px', color: '#0E7FE1', height: '10px', marginLeft: '5px' }}>
										+{item.apu_type.length - 2} more
									</a>
								)}
								{item.apu_type.length > 2 && showMore[`chip_${item.id}`] && (
									<a href="#" onClick={(e) => {
										e.preventDefault();
										toggleDescription(`chip_${item.id}`);
									}} style={{ fontSize: '10px', color: '#0E7FE1', height: '10px', marginLeft: '5px' }}>
										show less
									</a>
								)}
							</>
						) : '--'}
					</div>
				</TableCell>
				</>:null}
				<TableCell><div style={{ width: '150px' }}>{item?.is_llp_event === true ? 'YES': 'NO' }</div></TableCell>
				<TableCell><div style={{ width: '150px' }}>{numberWithCommas(item?.ground_time)}</div></TableCell>
				<TableCell><div style={{ width: '150px' }}>{numberWithCommas(item?.hours)}</div></TableCell>
				<TableCell><div style={{ width: '150px' }}>{numberWithCommas(item?.cycles)}</div></TableCell>
				<TableCell><div style={{ width: '150px' }}>{numberWithCommas(item?.months)}</div></TableCell>
				<TableCell><div style={{ width: '150px' }}>{numberWithCommas(item?.days)}</div></TableCell>
				<TableCell><div style={{ width: '150px' }}>{item?.year || '--'}</div></TableCell>
                <TableCell> <div style={{ width: '150px' }}>{item?.cost !== null && item?.cost !== undefined ? `$${numberWithCommas(item.cost)}` : '--'}</div> </TableCell>
				<TableCell><div style={{ width: '150px' }}>{item?.escalation || '--'}</div></TableCell>
				<TableCell><div style={{ width: '150px' }}>{item?.category?.name || '--'}</div></TableCell>
				<TableCell>
					<div style={{ width: '150px' }}>
						{item?.created_by?.name || '--'}
						{item?.created_by?.name ?
							<p style={{ fontSize: '11px', opacity: '0.8' }}>{moment(item?.created_at).format(displayDateFormat)}</p> : null
						}
					</div>
				</TableCell>
				<TableCell>
					<div style={{ width: '150px' }}>
						{item?.updated_by?.name || '--'}
						{item?.updated_by?.name ?
							<p style={{ fontSize: '11px', opacity: '0.8' }}>{moment(item?.updated_at).format(displayDateFormat)}</p> : null
						}
					</div>
				</TableCell>
				<TableCell>
					{item?.remarks && item?.remarks?.length > 30 ? (
						<div style={{ width: '200px' }}>
							{showMore[item?.field] ? (
								<span>
									<span dangerouslySetInnerHTML={{ __html: item?.remarks && item?.remarks.replace(/\n/g, '<br />') }} />
									<a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {" "}less </a>
								</span>
							) : (
								<span>
									<span dangerouslySetInnerHTML={{ __html: item?.remarks && item?.remarks.substring(0, 25).replace(/\n/g, '<br />'), }} />
									<a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {" "}..more </a>
								</span>
							)}
						</div>
					) : (
						<div dangerouslySetInnerHTML={{ __html: item?.remarks || '--', }} />
					)}
				</TableCell>
			</TableRow>
		</>
	)
}

export default SvEventsList